<template>
  <div>
    <Breadcrumbs main="Users" :title="`Profile ${user.fullname}`" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="user-profile">
        <div class="row">
          <!-- Basic Information-->
          <Basic_information></Basic_information>
          
        <div class="col-xl-6 col-md-6 box-col-6">
            <div class="row">
              <Summary></Summary>
              <SoftHardSkill></SoftHardSkill>
              <Certification></Certification>
              <Achievement></Achievement>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 box-col-6">
            <div class="row">
              <RiwayatPendidikan></RiwayatPendidikan>
              <WorkExperience></WorkExperience>
            </div>
          </div>
          <!-- user profile fifth-style end-->
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import Basic_information from "../../components/profile/basic_information.vue";
  import Summary from '../../components/profile/summary.vue';
  import RiwayatPendidikan from "../../components/profile/RiwayatPendidikan.vue";
  import Certification from "../../components/profile/Certification.vue";
  import Achievement from "../../components/profile/Achievement.vue";
  import WorkExperience from "../../components/profile/WorkExperience.vue";
  import SoftHardSkill from "../../components/profile/SoftHardSkill.vue";
  export default {
    components: { Basic_information, Summary, RiwayatPendidikan, Certification, Achievement, WorkExperience, SoftHardSkill },
    data() {
      return {
        user: JSON.parse(localStorage.getItem("user")),
      };
    },
  };
</script>
